import { Button } from 'antd';
import styles from './OrangeButton.module.scss';

// Defaults to full width, matching every existing call site's behavior.
// Pass fullWidth={false} instead of a local `width: auto !important`
// override at the call site.
export const OrangeButton = ({
  children,
  className,
  fullWidth = true,
  ...props
}) => (
  <Button
    className={[
      styles.orangeButton,
      !fullWidth && styles['orangeButton--auto'],
      className,
    ]
      .filter(Boolean)
      .join(' ')}
    {...props}
  >
    {children}
  </Button>
);
